<template>
  <div>
    <yjh-header :activeIndex="idnex"></yjh-header>
    <div class="newMobile_mobile">
      <div class="nav_mobile">
        <div class="navItem" :class="{ active: 0 == mobileNavIndex }" @click="navClick_0">
          <div class="icon">
            <i class="iconfont iconxinwenzixun"></i>
          </div>
          <div class="nav_title">新闻资讯</div>
        </div>
        <div class="navItem" :class="{ active: 1 == mobileNavIndex }" @click="navClick_1">
          <div class="icon">
            <i class="iconfont iconshipin"></i>
          </div>
          <div class="nav_title">视频媒体</div>
        </div>
        <div class="navItem" :class="{ active: 2 == mobileNavIndex }" @click="navClick_2">
          <div class="icon">
            <i class="iconfont icongongsiqiye"></i>
          </div>
          <div class="nav_title">企业资讯</div>
        </div>
      </div>
      <yjh-news v-if="mobileNavIndex == 0"></yjh-news>
      <yjh-video v-if="mobileNavIndex == 1"></yjh-video>
      <yjh-enterprise v-if="mobileNavIndex == 2"></yjh-enterprise>
    </div>
    <yjh-footer></yjh-footer>
  </div>
</template>

<script>
import footer from "@/layouts/footer";
import header from "@/layouts/header";
import sNav from "@/layouts/sNav";
import news from "./component/news";
import video from "./component/video";
import enterprise from "./component/enterprise";
export default {
  components: {
    "yjh-footer": footer,
    "yjh-header": header,
    "yjh-sNav": sNav,
    "yjh-news": news,
    "yjh-video": video,
    "yjh-enterprise": enterprise,
  },
  props: ["sNav", "header"],
  data() {
    return {
      idnex: "0",
      titleArr: [
        {
          id: 0,
          status: true,
          title: "新闻资讯",
          sTitle: "News Information",
        },
        {
          id: 1,
          status: false,
          title: "视频媒体",
          sTitle: "Video Media",
        },
        {
          id: 2,
          status: false,
          title: "企业资讯",
          sTitle: "Enterprise Information",
        },
      ],

      mobileNavIndex: "0",
    };
  },
  created() {},
  methods: {
    navClick_2() {
      this.mobileNavIndex = 2;
    },
    navClick_1() {
      this.mobileNavIndex = 1;
    },
    navClick_0() {
      this.mobileNavIndex = 0;
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  margin-top: 30px;
  font-size: 30px;
}
@media screen and (max-width: 999px) {
  .newMobile_mobile {
    .nav_mobile {
      display: flex;
      justify-content: space-around;
      .navItem {
        text-align: center;
        .icon {
          margin: 10px 0;
          .iconfont {
            font-size: 24px;
          }
        }
        .nav_title {
          margin-bottom: 10px;
        }
      }
      .active {
        color: #da261d;
      }
    }
  }
}
</style>
